import React, { useState } from 'react';

const sizeClasses = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
} as const;

const textSizeClasses = {
  xs: 'text-chip',
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-xl',
} as const;

export interface GsAvatarProps {
  name: string;
  photoUrl?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

function makeInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export function GsAvatar({ name, photoUrl, size = 'md', className = '' }: GsAvatarProps) {
  const [imgError, setImgError] = useState(false);
  const initials = makeInitials(name);
  const showPhoto = photoUrl && !imgError;

  return (
    <div
      className={`${sizeClasses[size]} rounded-full shrink-0 inline-flex items-center justify-center ${
        /* Ces deux classes s'écrivaient SANS numéro d'étape (`brand` nu, au
           lieu de `brand-500`). Or `brand` est un objet d'échelle, pas une
           couleur : Tailwind n'émettait rien, et les initiales s'affichaient
           sans pastille ni couleur de marque — dans TOUTES les apps, puisque
           ce composant est partagé. Le contrôle de rendu ne pouvait pas le
           voir : sa grammaire exigeait un numéro d'étape.
           Mesure 2026-09-22, lot `fix-huit-couleurs-sans-style`. */
        showPhoto ? '' : 'bg-brand-500/10 text-brand-500'
      } ${className}`}
    >
      {showPhoto ? (
        <img
          src={photoUrl}
          alt={name}
          className={`${sizeClasses[size]} rounded-full object-cover`}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className={`${textSizeClasses[size]} font-bold leading-none select-none`}>
          {initials}
        </span>
      )}
    </div>
  );
}
